import { useParams } from "react-router-dom";
import ResultFormLayout from "./components/ResultFormLayout";
import { useResultForm } from "./hooks/useResultForm";

const RegisterResult = () => {
  let { id: serialNumber } = useParams();
  const {
    selectedOption,
    setSelectedOption,
    formErrors,
    loading,
    submit,
    handleOnChange,
  } = useResultForm(serialNumber, { loadExisting: true });

  return (
    <ResultFormLayout
      serialNumber={serialNumber}
      heading={`Result update for semen analysis kit ${serialNumber}`}
      primaryLabel="Update & close"
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
      formErrors={formErrors}
      loading={loading}
      onSubmit={submit}
      onCancel={() => globalThis.history.back()}
      onChangeOption={handleOnChange}
    />
  );
};

export default RegisterResult;
